import { useTranslate, IResourceComponentsProps } from "@pankod/refine-core";
import {
  Create,
  Form,
  Input,
  useForm,
} from "@pankod/refine-antd";

import "react-mde/lib/styles/css/react-mde-all.css";

import { INews } from "interfaces";

export const NewsCreate: React.FC<IResourceComponentsProps> = () => {
  const t = useTranslate();

  const { formProps, saveButtonProps } = useForm<INews>();

  return (
    <Create saveButtonProps={saveButtonProps}>
      <Form {...formProps} layout="vertical">
        <Form.Item label={t("news.fields.title")} name="title" rules={[{ required: true }]}>
          <Input />
        </Form.Item>
        <Form.Item label={t("news.fields.url")} name="url">
          <Input />
        </Form.Item>
        <Form.Item label={t("news.fields.description")} name="description" rules={[{ required: true }]}>
          <Input />
        </Form.Item>
        <Form.Item label={t("news.fields.date")} name="date" rules={[{ required: true }]}>
          <Input />
        </Form.Item>
      </Form>
    </Create>
  );
};
